import { data } from "alpinejs/src/datas"

const product = ({ product, variant }) => ({
  urlParams: "",
  variants: null,
  selectedVariant: null,
  selectedSwatch: null,
  currentProduct: null,
  selectedVariantDimensions: null,
  optionRadios: null,
  optionAllRadios: null,
  slider: null,
  selectedVariantImageID: 0,
  productGalleryContainer: null,
  showProductFullSpecs: false,
  productFullSpecsDrawerIsOpen: false,
  productOptionsContainer: null,
  selectedOptionsValuesId: [],
  unavailableVariants: null,
  unavailableOptionsValues: [],
  unavailableVariantsTitles: [],
  selectedOptionPosition: 0,
  hasDimensions: false,
  showStickyButton: false,
  showPopup: false,
  subscriptionModalOpen: false,
  thumbnailSlider: null,
  mainSlider: null,
  selectedPlan: "subsave",
  hasSellingPlan: false,
  sellingPlanId: null,
  selectedVariantSaleAllocationPrice: null,
  isPlaying: false,
  selectedOptions: [],
  checkedRadios: [],
  productContainer: null,
  activeSlideIndex: null,
  /*hidePauseButton: false,*/
  isAutoplay: false,
  prevArrow: null,
  nextArrow: null,
  init() {
    this.prevArrow = document.querySelector("[data-thumbs-arrow-prev]")
    this.nextArrow = document.querySelector("[data-thumbs-arrow-next]")
    this.productContainer = document.querySelector("[data-main-product]")
    this.optionAllRadios = [...document.querySelectorAll("[data-options]")]
    this.checkedRadios = this.optionAllRadios.filter((option) => option.checked)
    if (this.checkedRadios.length) {
      this.checkedRadios.forEach((radio) => {
        this.selectedOptions.push(radio.value)
      })
    }

    const inStockContainer = document.querySelector("[data-form-container]")
    this.urlParams = new URL(window.location.href)
    this.currentProduct = product
    this.variants = product.variants
    this.selectedVariant = variant
    if (this.selectedVariant.featured_media) {
      this.selectedVariantImageID = this.selectedVariant.featured_media.id
    }
    this.productGalleryContainer = this.$refs.productGallery
    this.showStickyButton = !this.isElementInViewport(inStockContainer)
    window.addEventListener("scroll", (event) => {
      if (inStockContainer) {
        this.showStickyButton = !this.isElementInViewport(inStockContainer)
      }
    })
    this.drawURL()
    this.$nextTick(() => {
      this.mainSlider.on("slideChange", (event) => this.toggleVideo(event))
    })
  },
  getSelectedVariant(event, variant) {
    this.selectedVariant = this.variants.filter(
      (variant) =>
        variant.title.trim().toLowerCase() ===
        this.optionAllRadios
          .filter((radio) => radio.checked)
          .map((radio) => radio.value)
          .join(" / ")
          .trim()
          .toLowerCase()
    )[0] || variant.variant

    if (this.selectedVariant) {
      if (this.selectedVariant.featured_media) {
        this.selectedVariantImageID = this.selectedVariant.featured_media.id
      }
      this.drawURL()
      this.slideToSelectedVariantImage(this.selectedVariantImageID)
    }

    if (this.currentProduct.options.length > 1) {
      this.setAvailableVariants(event)
    }
  },
  setAvailableVariants(event) {
    this.selectedOptionPosition = event.target.getAttribute(
      "data-option-position"
    )
    /*this.selectedOptions[this.selectedOptionPosition] = event.target.value*/
    this.unavailableVariants = this.variants
      .filter(
        (variant) =>
          variant.options[this.selectedOptionPosition] === event.target.value
      )
      .filter((variant) => !variant.available)

    this.unavailableOptionsValues = []
    this.optionAllRadios.forEach((radio) => {
      radio.classList.remove("disabled")
    })

    if (this.unavailableVariants.length) {
      this.unavailableVariants.forEach((variant) => {
        variant.options.forEach((option) => {
          if (event.target.value !== option) {
            this.unavailableOptionsValues.push(option)
          }
        })
      })

      if (this.unavailableOptionsValues.length) {
        this.unavailableOptionsValues.forEach((value) => {
          if (
            this.optionAllRadios.filter((radio) => radio.value === value).length
          ) {
            this.optionAllRadios
              .filter((radio) => radio.value === value)
              .forEach((radio) => {
                radio.classList.add("disabled")
              })
          }
        })
      }
    }

    /*this.selectedOptionPosition = this.selectedVariant.options.indexOf(event.target.value) + 1
    this.unavailableOptionsValues = []
    this.unavailableVariantsTitles = []
    const optionsList = [...document.querySelectorAll(`.options-list`)]
    const notSelectedOptionsList = optionsList.filter(list => +list.getAttribute("data-option-position") !== this.selectedOptionPosition)

    this.unavailableVariants = this.variants.filter((variant) => variant.options.includes(event.target.value)).filter((variant) => !variant.available)
    notSelectedOptionsList.forEach((option, index) => {
        this.optionRadios = option.querySelectorAll("[data-product-variants]")
    })

    this.optionRadios.forEach((radio) => {
        /!*radio.disabled = false*!/
        radio.classList.remove("disabled")
    })

    if (this.unavailableVariants.length > 0) {
        this.unavailableVariants.forEach((variant) => {
            if (!this.unavailableVariantsTitles.includes(variant.title)) {
                this.unavailableVariantsTitles.push(variant.title)
            }
            variant.options.forEach((option) => {
                if (!this.unavailableOptionsValues.includes(option)) {
                    this.unavailableOptionsValues.push(option)
                }
            })
        })
    }

    if (this.unavailableOptionsValues.length > 0) {
        this.unavailableOptionsValues.forEach((value) => {
            this.optionRadios.forEach((radio) => {
                if (radio.value === value && value !== event.target.value) {
                    /!*radio.disabled = true*!/
                    radio.classList.add("disabled")
                }
            })
        })
    }*/
  },
  slideToSelectedVariantImage(id) {
    if (this.productGalleryContainer.querySelector(`[data-image-id="${id}"]`)) {
      this.selectedIndex = this.productGalleryContainer
        .querySelector(`[data-image-id="${id}"]`)
        .getAttribute("data-slide-index")
      this.mainSlider.slideTo(this.selectedIndex, 100, null)
    }
  },
  incrementQty(event) {
    Alpine.store("cart").qty++
  },
  decrementQty(event) {
    if (Alpine.store("cart").qty > 1) {
      Alpine.store("cart").qty--
    }
  },
  drawURL() {
    this.urlParams.searchParams.set("variant", this.selectedVariant.id)
    history.replaceState(this.selectedVariant.id, "variant", this.urlParams)
  },
  changeSellingPlan(event) {
    this.sellingPlanId = event.target.value
    if (
      this.selectedVariant.selling_plan_allocations.find(
        (item) => item.selling_plan_id == this.sellingPlanId
      )
    ) {
      this.selectedVariantSaleAllocationPrice =
        this.selectedVariant.selling_plan_allocations.find(
          (item) => item.selling_plan_id == this.sellingPlanId
        ).price
    }
  },
  switchSubscription(event) {
    this.selectedPlan = event.target.value
  },
  openSubscriptionModal() {
    this.subscriptionModalOpen = true
  },
  closeSubscriptionModal() {
    this.subscriptionModalOpen = false
  },
  isElementInViewport(el) {
    const rect = el.getBoundingClientRect()
    return (
      rect.top + el.clientHeight >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight)
    )
  },
  toggleVideo(event) {
    let index_currentSlide = event.realIndex
    let currentSlide = event.slides[index_currentSlide]
    let videoContainer = currentSlide.querySelector(".video-container")
    let playButton = currentSlide.querySelector("button")

    this.stopVideo()

    if (videoContainer) {
      if (this.isAutoplay) {
        this.playVideo(playButton, index_currentSlide)
      }
    }
  },
  playVideo($el, index) {
    const videoContainer = document.querySelectorAll(`[data-slide-index="${index}"]`)
    videoContainer.forEach((container) => {
        if (container.querySelector("video")){
            container.querySelector("video").play()
        }
    })
    this.isPlaying = true
    this.showPauseButton(index)
    this.hidePlayButton(index)
  },
  pauseVideo($el, index) {
    const videoContainer = document.querySelectorAll(`[data-slide-index="${index}"]`)
    videoContainer.forEach((container) => {
        if (container.querySelector("video")){
            container.querySelector("video").pause()
        }
    })
    this.isPlaying = false
    this.hidePauseButton(index)
    this.showPlayButton(index)
  },
    stopVideo(index){
      this.isPlaying = false
      const video = this.productContainer.querySelectorAll("video")
      if (video.length) {
        video.forEach(vid => {
          vid.pause()
          vid.currentTime = 0
        })
      }
      const playButtons = this.productContainer.querySelectorAll("[data-play-button]")
      const pauseButtons = this.productContainer.querySelectorAll("[data-pause-button]")
      if (playButtons){
        playButtons.forEach((button)=>{
          button.classList.remove("!hidden")
        })
      }

      if (pauseButtons){
        pauseButtons.forEach((button)=>{
          button.classList.add("!hidden")
        })
      }
    },
  hidePauseButton(index) {
    const pauseButtons = this.productContainer.querySelectorAll(
      `[data-pause-index="${index}"]`
    )
    if (pauseButtons.length) {
      pauseButtons.forEach((pauseButton) => {
        pauseButton.classList.add("!hidden")

        setTimeout(() => {
          pauseButton.classList.add("opacity-0")
        }, 1000)
      })
    }
  },
  showPauseButton(index) {
    const pauseButtons = this.productContainer.querySelectorAll(
      `[data-pause-index="${index}"]`
    )
    const playButtons = this.productContainer.querySelectorAll(
      `[data-play-index="${index}"]`
    )

    if (pauseButtons.length) {
      pauseButtons.forEach((pauseButton) => {
        pauseButton.classList.remove("!hidden")

        setTimeout(() => {
          pauseButton.classList.remove("opacity-0")
        }, 1000)
      })
    }
  },
  showPlayButton(index) {
    const playButtons = this.productContainer.querySelectorAll(
      `[data-play-index="${index}"]`
    )

    if (playButtons.length) {
      playButtons.forEach((playButton) => {
        playButton.classList.remove("!hidden")
      })
    }
  },
  hidePlayButton(index) {
    const playButtons = this.productContainer.querySelectorAll(
      `[data-play-index="${index}"]`
    )

    if (playButtons.length) {
      playButtons.forEach((playButton) => {
        playButton.classList.add("!hidden")
      })
    }
  },
})

export default product

window.addEventListener("alpine:init", () => {
  Alpine.data("mainProduct", product)
})
